export default "__VITE_ASSET__TtkouCfU__"